import anime from './anime';
import clients from './clients';
import consts from './consts';
import indexers from './indexers';
import layout from './layout';
import general from './general';
import metadata from './metadata';
import notifiers from './notifiers';
import postprocessing from './postprocessing';
import search from './search';
import subtitles from './subtitles';
import system from './system';

const modules = {
    anime,
    clients,
    consts,
    indexers,
    layout,
    general,
    metadata,
    notifiers,
    postprocessing,
    search,
    subtitles,
    system
};

const state = {};

const mutations = {};

const getters = {};

const actions = {};

export default {
    state,
    mutations,
    getters,
    actions,
    modules
};
